import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { PortalContextService } from './portal-context.service';

export const NOT_LINKED_ROUTE = 'not-linked';

/**
 * Sends an account that is not linked to a customer to the "not linked" page instead of letting
 * the orders or invoices call their list endpoints (which answer 403 for such an account).
 * When the context cannot be loaded the route opens; the API still refuses what it must.
 */
export const linkedRelationGuard: CanActivateFn = () => {
  const router = inject(Router);

  return inject(PortalContextService)
    .isLinked()
    .pipe(
      take(1),
      map((linked) => linked || router.createUrlTree([NOT_LINKED_ROUTE])),
      catchError(() => of(true))
    );
};
